<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Stock Opname Form
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter Items
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Audit Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="header.startdate" readonly></b-form-input>
                <b-input-group-append>
                  <span class="input-group-text">-</span>
                </b-input-group-append>
                <b-form-input v-model="header.enddate" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Note/Description</label>
                </b-input-group-prepend>
                <b-form-input v-model="header.uraian" placeholder="Note/Description" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-form-checkbox
                v-model="showItemRecorded"
                value="1"
                unchecked-value="0"
                style="margin-left:10px;"
              >Show item recorded</b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="showFilter">
        <b-col md="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Posting Category</label>
            </b-input-group-prepend>
            <b-form-select v-model="filter.catgname" :plain="true" :options="itemCategories"></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Asset Code</label>
            </b-input-group-prepend>
            <b-form-input v-model="filter.asetid" placeholder="Asset Code"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Location</label>
            </b-input-group-prepend>
            <b-form-input v-model="filter.aslocat" placeholder="Location Asset"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>User</label>
            </b-input-group-prepend>
            <b-form-input v-model="filter.asuser" placeholder="User Asset"></b-form-input>
          </b-input-group>
          <b-row style="margin-left: 128px;">
            <b-button class="btn btn-success" @click="refresh()">
              <i class="fa fa-refresh"></i> Reload
            </b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear Filter
            </b-button>
          </b-row>
        </b-col>
      </b-row>
      <br />
      <div class="report-wraper">
        <table style="width: 99%;">
          <thead>
            <tr>
              <th width="20px">No.</th>
              <th width="180px">Asset Code</th>
              <th width="500px">Item Name</th>
              <th width="200px">Type/Series</th>
              <th width="200px">Posting Category</th>
              <th width="200px">Asset User - Location</th>
              <th width="300px" style="text-align:center;">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row,index) in dataItems"
              :key="row.invOpnamDtlKey"
              @click="confirmAction(row)"
              :class="{ selected: row.isSelected ,beforeOpname :row.qtyOpname===row.qtySystem?false:true }"
            >
              <td>{{index+1}}</td>
              <td>{{row.asetid}}</td>
              <td>{{row.asdesc}}</td>
              <td>{{row.asmodel}}</td>
              <td>{{row.catgname}}</td>
              <td>{{row.asuser ?row.asuser+' - ':''}}{{row.aslocat}}</td>
              <td v-if="(row.isSelected==1)" style="text-align:center;">
                <b-input-group>
                  <b-form-select
                    v-model="model.status_id"
                    :options="assetsStatus"
                    :state="!$v.model.status_id.$error"
                  >
                    <template v-slot:first>
                      <option :value="null" disabled>-- Select Status --</option>
                    </template>
                  </b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-form-textarea
                    v-model="model.opnamestatus"
                    placeholder="Remark..."
                    rows="3"
                    max-rows="6"
                    :state="!$v.model.opnamestatus.$error"
                  ></b-form-textarea>
                </b-input-group>
                <b-input-group>
                  <b-button variant="success" size="sm" @click.stop="save()">
                    <i class="fa fa-check"></i>Save
                  </b-button>
                  <b-button variant="danger" size="sm" @click.stop="unselect()">
                    <i class="fa fa-times"></i>
                  </b-button>
                </b-input-group>
              </td>
              <td v-else style="text-align:center;">
                <span v-if="(row.opnamestatus !== null)">
                  {{row.opnamestatus}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>
<style lang="scss">
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  min-height: 100px;
  border: 1px solid silver;
  table {
    font-size: smaller;
    th {
      border: 1px solid silver;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    td {
      border: 1px solid silver;
      padding: 0 10px;
      height: 25px;
    }

    td.tebal {
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: rgba(91, 192, 222, 0.2) !important;
      cursor: default;
    }

    tbody tr.selected {
      background-color: rgba(92, 184, 92, 0.2) !important;
      cursor: default;
    }

    tbody tr.beforeOpname {
      background-color: #f2dddd !important;
      cursor: default;
    }
  }
}
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import opname from "../../apis/fa_opname";
import item from "../../apis/item";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      assetOpnamDtlKey: { required },
      status_id: { required },
      opnamestatus: { required }
    }
  },
  data() {
    return {
      saveEnabled: true,
      showFilter: false,
      showItemRecorded: "1",
      filter: {
        asetid: "",
        catgname: "",
        aslocat: "",
        asuser: ""
      },
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      uanguser: this.$store.state.user.matauang,
      itemCategories: [{ value: "", text: "-- ALL--" }],
      model: {
        assetOpnamDtlKey: "",
        status_id: null,
        opnamestatus: ""
      },
      header: {},
      dataDetail: [],
      dataItems: [], // <- data hasil filter
      assetsStatus: [],
      selectedRowId:''
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    }
  },
  watch: {
    showItemRecorded: function(newVal) {
      setTimeout(() => {
        this.refresh();
      }, 100);
    },
    dataItems: function(val) {
      setTimeout(() => {
        let findIdx = val.findIndex(x => x.status_id === null);
        this.confirmAction(this.dataItems[findIdx]);
      }, 100);
    }
  },
  created: async function() {
    const [a, b] = await Promise.all([
      opname.getStatus(),
      opname.getCategory()
    ]);

    this.assetsStatus = a.reduce((newArr = [], el, idx) => {
      el.text = el.status_name;
      el.value = el.status_id;
      newArr.push(el);
      return newArr;
    }, []);

    b.forEach(el => {
      el.text = el.catgname;
      el.value = el.id;
      this.itemCategories.push(el);
    });

    if (this.$route.params.assetOpnamKey) {
      toastr.info("Loading Stock Opname Detail, please wait");
      this.data();
    }
  },
  methods: {
    data: async function() {
      try {
        const data = await opname.detail(this.$route.params);
        this.header = data[0][0];
        this.header.startdate = moment(this.header.startdate).format(
          "DD MMM YYYY"
        );
        this.header.enddate = moment(this.header.enddate).format("DD MMM YYYY");
        this.dataDetail = data[1];

        data[1].forEach((element, idx) => {
          // const findShelf = this.shelfList.find(
          //   x => x.value === element.asetid
          // );
          // if (!findShelf)
          //   this.shelfList.push({
          //     value: element.asetid,
          //     text: element.asetid
          //   });
        });

        // code below just for testing
        this.refresh();
        toastr.clear;
      } catch (error) {
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    confirmAction: function(record) {
      if (this.row) delete this.row.isSelected;
      this.row = record;
      if (this.selectedRowId !== record.assetOpnamDtlKey ) {
        for (var key in record) {
          this.model[key] = record[key];
        }
        this.selectedRowId =record.assetOpnamDtlKey 
      }
      record.isSelected = 1;

      this.$forceUpdate();
    },
    unselect: function() {
      if (this.row) delete this.row.isSelected;
      this.row = undefined;
      this.$forceUpdate();
    },
    refresh: async function() {
      let dataItems = this.dataDetail.reduce((arr = [], el, idx) => {
        if (this.showItemRecorded === "0" && el.status_id === null) {
          arr.push(el);
        } else if (
          this.showItemRecorded === "1" &&
          (el.status_id === null || el.status_id !== null)
        ) {
          arr.push(el);
        }
        return arr;
      }, []);

      if (this.filter.catgname || this.filter.asetid) {
        dataItems = dataItems.filter(el => {
          if (this.filter.catgname && this.filter.catgname !== el.catgname)
            return false;

          if (this.filter.asetid && this.filter.asetid !== el.asetid)
            return false;

          if (this.filter.aslocat && this.filter.aslocat !== el.aslocat)
            return false;

          if (this.filter.aslocat && this.filter.aslocat !== el.aslocat)
            return false;

          return true;
        });
      }
      this.dataItems = dataItems;
    },
    save: async function() {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          //lakukan pangil API untuk Update ke Database disini
          if (this.row) {
            const assetSts = this.assetsStatus.find(
              x => x.status_id === this.model.status_id
            );
            this.model.opnamestatus = assetSts ? assetSts.status_name +' | '+this.model.opnamestatus : "";
            const data = await opname.saveAssetAudit(this.model);
            // this.row.opnamestatus = this.model.opnamestatus;
          }
          this.unselect();
          this.data();
          // lebih baik ditambahkan untul autoselect Next Item , & ready to update
        } catch (error) {
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "Save Opname Item  Error");
        }
      }
    },
    clearFilter() {
      this.filter.asetid = "";
      this.filter.catgname = "";
      this.refresh();
    },
    close() {
      //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if (
        this.$store.state.prevRoute.name &&
        this.$store.state.prevRoute.name !== "procurement.receivingfrm"
      ) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        // router.push({name:'payable.apinv'});
        router.push("home");
      }
    }
  }
};
</script>
